@if (isTrue) {
  <span class="bool bool-true">
    <svg class="bool-check" viewBox="0 0 14 14" width="12" height="12" aria-hidden="true">
      <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2.5 7.6 5.7 10.8 11.5 3.6"/>
    </svg>
    <span class="bool-label">{{ trueLabel }}</span>
  </span>
}
